import { Box, Breadcrumbs, Grid, Typography, Link } from '@mui/material';
import React from 'react';
import WhisperInterest from '../Administration/HomePage/WhisperInterest';

export default function MonthlyInterest({ perm }: { perm: string }) {
    const mode = localStorage.getItem('theme') || 'dark';
    return (
        <Box sx={{ display: 'flex', width: '100%', height: '100%'}}>
            <Grid container spacing={2} sx={{ width: '100%', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography variant="h4" sx={{ fontSize: '1.5rem !important', textAlign: 'center', fontFamily: 'Trebuchet MS', fontWeight: 'bold' }}>Monthly Whisper Concerns</Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Typography variant="body1" color="textSecondary" sx={{ textAlign: 'center', fontFamily: 'Trebuchet MS', marginBottom: 2 }}>
                        Here you can see the monthly whisper insights for your customers.
                    </Typography>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 0, boxShadow: 'none' }}>
                        <Link underline="hover" color="inherit" href="/admin/whispers">Opportunities</Link>
                        <Typography sx={{ color: 'primary.main', fontSize: 'clamp(0.9rem, 0.9rem, 0.9rem) !important' }}>Monthly Whisper Insights</Typography>
                    </Breadcrumbs>
                </Grid>
                <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                    <WhisperInterest perm={perm} mode={mode} height={600} />
                </Grid>
            </Grid>
        </Box>
    )
}